import type { RentalTemplateContextConfig } from "#lib/web-ui/rental/index.js";
import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

export const villasSiteConfig: RentalTemplateContextConfig = {
	floatingBanner: {
		title: "Move-In Special!",
		subTitle: "Call the office for details!"
	},
	name: "The Villas",
	tagline: "PRIME LOCATION, GREAT VALUE",
	logo: cloudinaryUrl("brand/the-villas/the-villas-long-dark", { width: 300 }),
	address: {
		street: "210 Northcross Dr",
		city: "Victoria",
		state: "TX",
		zip: "77904"
	},
	geo: {
		latitude: "28.8729452",
		longitude: "-96.9944951"
	},
	amenities: [
		"Swimming Pool",
		"Fitness Center",
		"Dog Park",
		"Pet Friendly",
		"Parking",
		"Laundry Facilities"
	],
	priceRange: "$$",
	metaDescription:
		"The Villas offers spacious apartments & townhomes in Victoria, TX's most convenient location - near Victoria Mall, shopping, dining, and Loop 463. Pool, brand new gym & dog park. Pet-friendly. Call (361) 573-0236!",
	metaKeywords:
		"The Villas, apartments Victoria TX, townhomes Victoria TX, Victoria TX apartments, apartments for rent Victoria TX, townhomes for rent Victoria TX, 1 bedroom apartments Victoria TX, 2 bedroom apartments Victoria TX, 3 bedroom apartments Victoria TX, 2 bedroom townhomes Victoria TX, 3 bedroom townhomes Victoria TX, apartments 77904, Northcross Dr apartments, apartments near Victoria Mall, apartments near Cinemark Theatres, apartments with pool Victoria TX, apartments with gym Victoria TX, apartments with dog park Victoria TX, apartments with private patios Victoria TX, apartments with balconies Victoria TX, apartments with assigned parking Victoria TX, quiet apartments Victoria TX, fully landscaped apartments Victoria TX, Victoria Texas rentals, The Villas rentals, apartments near shopping Victoria TX, apartments near restaurants Victoria TX, apartments with cabana Victoria TX, 24 hour gym apartments Victoria TX",
	buildiumPropertyIds: ["104767"],
	tenantPortal: "https://fergmar.managebuilding.com/Resident/portal/",
	contact: {
		phone: "361-573-0236",
		email: "leasing@thevillastx.com"
	},
	events: [],
	eventImage: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (1)", { width: 800 }),
	websiteUrl: "thevillastx.com",
	socialMedia: {
		facebook: "https://facebook.com/thevillasapartments",
		instagram: "https://instagram.com/thevillasvtx"
	},
	heroImage: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (11)", { width: 1920 }),
	heroVideoPublicId: "www/thevillastx-com/background-video",
	apartmentFeatures: [
		"Appliances Included",
		"Private Patios or Balconies",
		"Washer & Dryers Available",
		"Assigned Parking",
		"Cable Ready",
		"Quiet Setting",
		"Fully Landscaped"
	],
	communityFeatures: [
		"Pool with Cabana",
		"BRAND NEW Dog Park",
		"BRAND NEW 24-Hour Gym",
		"24 Hour Emergency Maintenance",
		"On-Site Manager"
	],
	detailsImage: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (11)", { width: 800 }),
	neighborhood: [
		"Moments from Victoria Mall and Cinemark Theatres.",
		"Close proximity to numerous dining options",
		"Part of the Victoria Independent School District (VISD).",
		"Conveniently located near major area employers.",
		"Extensive shopping nearby including Dillard's, JCPenney, Best Buy, TJ Maxx, and more.",
		"Easy access to grocery shopping at nearby Sam's Club and Walmart.",
		"Situated in the heart of Victoria's primary retail and commercial corridor.",
		"Short distance to Ethel Lee Tracy Park for outdoor space.",
		"Multiple pharmacies and essential services located within minutes.",
		"Easy access to Loop 463 (Zac Lentz Parkway) for convenient commuting."
	],
	floorPlans: [
		{
			key: "a1",
			name: "A1",
			beds: 1,
			baths: 1,
			sqFt: { min: 712, max: 712 },
			image: cloudinaryUrl("www/thevillastx-com/1bed-1bath", { width: 600 }),
			deposit: null
		},
		{
			key: "b1",
			name: "B1",
			beds: 2,
			baths: 1,
			sqFt: { min: 912, max: 912 },
			image: cloudinaryUrl("www/thevillastx-com/2bed-1bath", { width: 600 }),
			deposit: null
		},
		{
			key: "c1",
			name: "C1",
			beds: 2,
			baths: 1.5,
			sqFt: { min: 1162, max: 1162 },
			image: cloudinaryUrl("www/thevillastx-com/2bed-1_5bath", { width: 600 }),
			deposit: null
		},
		{
			key: "d1",
			name: "D1",
			beds: 2,
			baths: 2.5,
			sqFt: { min: 1084, max: 1084 },
			image: cloudinaryUrl("www/thevillastx-com/2bed-2_5bath", { width: 600 }),
			deposit: null
		},
		{
			key: "e1",
			name: "E1",
			beds: 3,
			baths: 2.5,
			sqFt: { min: 1512, max: 1512 },
			image: cloudinaryUrl("www/thevillastx-com/3bed-2_5bath", { width: 600 }),
			deposit: null
		}
	],
	propertyImages: [
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (11)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (24)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (25)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (22)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (17)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (16)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (18)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (19)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (20)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (21)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (23)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (2)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (3)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (4)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (5)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (6)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (7)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (8)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (9)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (10)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (12)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (13)", { width: 1200 }),
			alt: "The Villas Apartments"
		},
		{
			url: cloudinaryUrl("www/thevillastx-com/the_villas_apartments (14)", { width: 1200 }),
			alt: "The Villas Apartments"
		}
	],
	welcomeTagline: "THE LOCATION YOU WANT, THE SPACE YOU NEED",
	welcomeDescription:
		"The Villas offers the perfect combination of location, space, and value. Our community is conveniently located in Victoria's prime retail corridor - steps from Victoria Mall, Walmart, Cinemark Theatres, and countless dining options. With easy access to Loop 463, you're minutes from anywhere in Victoria. Choose from spacious 1, 2, and 3-bedroom apartments and townhomes, all featuring private patios or balconies. Enjoy our pool with cabana, brand new 24-hour fitness center, and new dog park. The Villas: where convenience meets comfort."
} as const;
